import { IMeasurementFacade, IMeasurementConfigurator, FPS_MEASUREMENT_LOGGER } from "./IMeasurements";
import { getLogger } from "@goodgamestudios/logger";

export class MeasurementFacade implements IMeasurementFacade {

    configurator: IMeasurementConfigurator;
    isRunning: boolean;
    isActive: boolean;

    private logger = getLogger(FPS_MEASUREMENT_LOGGER);

    public start(payload?: Object): void {
        this.logger.debug("MeasurementFacade.start is not implemented yet");
    }
    public stop(payload?: Object): void {
        this.logger.debug("MeasurementFacade.stop is not implemented yet");
    }
    public activate(): void {
        this.logger.debug("MeasurementFacade.activate is not implemented yet");
    }
    public deactivate(): void {
        this.logger.debug("MeasurementFacade.deactivate is not implemented yet");
    }

}
